// extracted by css-extract-rspack-plugin
export default {"handle_btn":"handle_btn___+k45r","table_icon":"table_icon___zlDCC","hiddenIcon":"hiddenIcon___8FYEj"};